import {
	approveBookFree,
	approveKakaoPay,
	bookFreeTemp,
	cancelFreeBook,
	cancelKCP,
	failBookTemp,
	failKakaoPay,
	failKcp,
	fetchBookList,
	fetchBookableDates,
	fetchBusLayout,
	fetchFareTargets,
	fetchPG,
	kakaoPay,
} from '@/api/book';

export default {
	async FETCH_BOOKABLE_DATES(_context, payload) {
		const response = await fetchBookableDates(payload);
		return response.data;
	},
	async FETCH_FARE_TARGETS(_context, payload) {
		const response = await fetchFareTargets(payload);
		if (response) {
			return response.data.data;
		}
	},
	async SET_FORWARD_LINES({ commit }, payload) {
		commit('SET_FORWARD_LINES', payload);
	},
	async SET_BACKWARD_LINES({ commit }, payload) {
		commit('SET_BACKWARD_LINES', payload);
	},
	async CLEAR_LINES({ commit }) {
		commit('CLEAR_LINES');
	},
	async FETCH_BUS_LAYOUT(_context, payload) {
		const response = await fetchBusLayout(payload);
		if (response) {
			return response.data.data;
		}
	},
	async FAIL_KCP(_context, payload) {
		const response = await failKcp(payload);
		if (response) {
			return response;
		}
	},
	async KAKAO_PAY(_context, payload) {
		const response = await kakaoPay(payload);
		if (response) {
			return response;
		}
	},
	async FAIL_KAKAO_PAY(_context, payload) {
		const response = await failKakaoPay(payload);
		if (response) {
			return response.data.data;
		}
	},
	async APPROVE_KAKAO_PAY(_context, payload) {
		const response = await approveKakaoPay(payload);
		if (response) {
			return response;
		}
	},
	async FETCH_PG({ commit }) {
		const response = await fetchPG();
		if (response.data.resultCode === 0) {
			commit('SET_PG_LIST', response.data.data);
		}
		return response.data;
	},
	async FETCH_BOOK_LIST({ commit }) {
		const response = await fetchBookList();
		if (response) {
			commit('SET_BOOK_LIST', response.data.data);
		}
		return response.data;
	},
	async CANCEL_KCP(_context, payload) {
		const response = await cancelKCP(payload);
		if (response) {
			return response;
		}
	},

	async BOOK_FREE_TEMP({ commit }, payload) {
		const response = await bookFreeTemp(payload);
		if (response.data.resultCode === 0) {
			commit('SET_BOOK_UID', response.data.data);
		}
		return response.data;
	},

	async APPROVE_BOOK_FREE(_context, payload) {
		const response = await approveBookFree(payload);
		return response.data;
	},

	async GET_BOOK_STEPS({ commit }, payload) {
		const response = await fetchBookableDates(payload);
		if (response) {
			commit('SET_BOOKABLE_DATES', response.data.data);
			commit('SET_BOOK_STEPS', response.data.data);
			return response.data.data;
		}
	},

	async GET_ETCBOOK_STEPS({ commit }, payload) {
		const response = await fetchBookableDates(payload);
		if (response) {
			commit('SET_ETC_BOOKABLE_DATES', response.data.data);
			commit('SET_ETCBOOK_STEPS', response.data.data);
			return response.data.data;
		}
	},

	async CANCEL_FREE_BOOK(_context, payload) {
		const response = await cancelFreeBook(payload);
		if (response) {
			return response.data.data;
		}
	},

	async FAIL_BOOK_TEMP(_context, payload) {
		const response = await failBookTemp(payload);
		return response.data;
	},

	async REMOVE_BOOK_STEP({ commit }, payload) {
		commit('REMOVE_BOOK_STEP', payload);
	},

	async REMOVE_ETC_BOOK_STEP({ commit }, payload) {
		commit('REMOVE_ETC_BOOK_STEP', payload);
	},

	async SET_IS_FORWARD_BOOK_COUNT_EXCEEDED({ commit }, payload) {
		commit('SET_IS_FORWARD_BOOK_COUNT_EXCEEDED', payload);
	},

	async SET_IS_BACKWARD_BOOK_COUNT_EXCEEDED({ commit }, payload) {
		commit('SET_IS_BACKWARD_BOOK_COUNT_EXCEEDED', payload);
	},

	async SET_BOOK_UID({ commit }, payload) {
		commit('SET_BOOK_UID', payload);
	},

	SET_BOOK_STEPS({ commit, state }) {
		commit('SET_BOOK_STEPS', state.bookableDates);
	},

	SET_ETCBOOK_STEPS({ commit, state }) {
		commit('SET_ETCBOOK_STEPS', state.etcBookableDates);
	},
};
